var config = {};

config.backend = {};
config.keycloak = {};

// config.backend.api_endpoint = process.env.BACKEND_API_ENDPOINT || 'http://localhost:9090';
config.backend.api_endpoint = process.env.BACKEND_API_ENDPOINT || '/api';   // ### Change to relative path

// ### BACKEND_CCTV_GATEWAY_IP can be IP or Hostname for WebRTC, RTSP endpoint
// config.backend.cctv_gateway_ip = process.env.BACKEND_CCTV_GATEWAY_IP || '10.151.11.221';
config.backend.cctv_gateway_ip = process.env.BACKEND_CCTV_GATEWAY_IP || 'wsl.local';
// config.backend.cctv_gateway_ip = process.env.BACKEND_CCTV_GATEWAY_IP || 'localhost';

config.keycloak.serverUrl = process.env.KEYCLOAK_SERVERURL || 'https://id.meca.in.th/auth'
config.keycloak.realm = process.env.KEYCLOAK_REALM || 'social'
config.keycloak.clientId = process.env.KEYCLOAK_CLIENT_ID || 'ev-survey'
config.keycloak.resourceAccess = process.env.KEYCLOAK_RESOURCE_ACCESS || 'ev-survey'
config.keycloak.adminRole = process.env.KEYCLOAK_ADMIN_ROLE || 'ev-survey-admin'

module.exports = config;
